import Tab from "../../plugins/tab.js";

// URL ハッシュから初期表示するタブを決定する
// 各 .js-tab-button に data-tab-anchor を付けておくと、ハッシュと一致したタブが開く
const hash = location.hash ? decodeURIComponent(location.hash.slice(1)) : "";

const elements = document.querySelectorAll(".js-tab");
elements.forEach((element) => {
  let defaultOpenPanel = 0;
  if (hash) {
    const buttons = [...element.querySelectorAll(".js-tab-button")];
    const matchedIdx = buttons.findIndex(
      (btn) => btn.dataset.tabAnchor === hash
    );
    if (matchedIdx >= 0) {
      defaultOpenPanel = matchedIdx;
    }
  }

  new Tab(element, {
    defaultOpenPanel,
    // tabWrapper: ".js-tab-list",
    // tabs: ".js-tab-button",
    // panelWrapper: ".js-tab-panel-wrapper",
    // panels: ".js-tab-panel",
  });
});